import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'environments/environment';
import { Group } from 'core/models/group';
import { HttpDataService } from './http-data.service';

@Injectable()
export class GroupsService extends HttpDataService {
  constructor(protected injector: Injector) {
    super(injector, '/core/groups');
  }

  getGroup(id: string): Observable<Group> {
    return super.getItem(id);
  }

  getGroupGame(id: string): Observable<any> {
    const cacheId = `${this.apiEndPoint}_${id}_groupGame`;
    const url = `${this.baseUrl}/${id}/game`;
    return this.fetchRequest(url, this.getRequestOptions(), null);
  }

  extend(groupId: string, endDate: Date) {
    const url = `${this.baseUrl}/${groupId}/extensions`;
    return super.postRequest(url, { endDate }, this.getRequestOptions());
  }

  recalculateResume(props: Object): Promise<any> {
    const url = `${environment.API_URL}/tasks/calculate-group-final-resume/run`;
    return super.postRequest(url, JSON.stringify(props), this.getRequestOptions());
  }

  endSession(endSessionDate: string, groupId: string, startSessionDate: string): Promise<any> {
    const url = `${environment.API_URL}/mars/groups/${groupId}/endSession`;
    return super.putRequest(url, JSON.stringify({ endSessionDate, startSessionDate }), this.getRequestOptions());
  }
}
